import angular from 'angular';

angular.module('cxNotifications', ['commonServices']);
